<template>
  <div style="margin-bottom: 24px;">
    <div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <el-checkbox v-model="isDefaultPayee" style="font-weight: bold;margin-bottom: 8px;">默认收款账号</el-checkbox>
      </div>
    </div>
    <div style="display: flex; justify-content: space-around" v-show="!isDefaultPayee">
      <el-scrollbar class="showBox">
        <p style="margin-bottom: 16px;">收款包名</p>
        <div>
          <label style="font-weight: bold;margin-bottom: 8px;">Android平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateAndroid" v-model="checkAllAndroid" @change="androidHandleCheckAllChange" :disabled="androidCheckAllDisabled">全选</el-checkbox>
          <el-checkbox-group v-model="checkedAndroid" @change="androidHandleCheckedChange">
            <el-checkbox v-for="item in packageListAndroid" :label="item.id" :key="item.id" style="margin:0;width:33%;" size="small" :disabled="otherCheckedIdArr.includes(item.id)">{{item.packageName}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">鸿蒙平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateHm" v-model="checkAllHm" @change="hmHandleCheckAllChange" :disabled="hmCheckAllDisabled">全选</el-checkbox>
          <el-checkbox-group v-model="checkedHm" @change="hmHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in packageListHm" :label="item.id" :key="item.id" style="margin:0;width:33%;" size="small" :disabled="otherCheckedIdArr.includes(item.id)">{{item.packageName}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-scrollbar>
    </div>
    <div>
      <div class="dialog-footer" style="text-align: center;">
        <el-button @click.native="cancel" >取消</el-button>
        <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
      </div>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { updatePayeeSetting, listPackageNameAndChannel } from "@/api/url";

export default {
  name: "GiftManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      alipayForm: this.value.alipayForm,
      otherCheckedIdArr: this.value.otherCheckedIdArr,
      loading: false,

      isDefaultPayee: this.value.alipayForm.state == 1,

      //Android包名列表
      packageListAndroid: [],
      checkAllAndroid: true,
      checkedAndroid: [],
      isIndeterminateAndroid: false,
      androidCheckAllDisabled: true,

      //Hm渠道列表
      packageListHm: [],
      checkAllHm: true,
      checkedHm: [],
      isIndeterminateHm: false,
      hmCheckAllDisabled: true,

    }
  },
  methods: {

    cancel() {
      this.$emit("close");
    },

    //hm
    hmHandleCheckAllChange(val) {
      if(val) {
        for(let item of this.packageListHm) {
          this.checkedHm.push(item.id)
        }
      } else {
        this.checkedHm = [];
      }
      this.isIndeterminateHm = false;
    },
    hmHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllHm = checkedCount === this.packageListHm.length;
      this.isIndeterminateHm = checkedCount > 0 && checkedCount < this.packageListHm.length;
    },

    //Android
    androidHandleCheckAllChange(val) {
      if(val) {
        for(let item of this.packageListAndroid) {
          this.checkedAndroid.push(item.id)
        }
      } else {
        this.checkedAndroid = [];
      }
      this.isIndeterminateAndroid = false;
    },
    androidHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllAndroid = checkedCount === this.packageListAndroid.length;
      this.isIndeterminateAndroid = checkedCount > 0 && checkedCount < this.packageListAndroid.length;
    },

    //包名、渠道
    getPackageChannelList() {
      let _this = this;
      getFormData(listPackageNameAndChannel).then((data)=>{
        let {msg, code} = data;
        if(code == 200) {
          for(let item of data.data) {
            if(item.platformType == 1) {
              _this.packageListAndroid.push(item);
              if(!this.otherCheckedIdArr.includes(item.id)) {
                _this.androidCheckAllDisabled = false;
              }
            } else if(item.platformType == 4) {
              _this.packageListHm.push(item);
              if(!this.otherCheckedIdArr.includes(item.id)) {
                _this.hmCheckAllDisabled = false;
              }
            }
          }
          for(let item of _this.alipayForm.packageNameList) {
            if(item.platformType == 1) {
              _this.checkedAndroid.push(item.id);
              _this.androidHandleCheckedChange(_this.checkedAndroid)
            } else if(item.platformType == 4) {
              _this.checkedHm.push(item.id);
              _this.hmHandleCheckedChange(_this.checkedHm);
            }
          }
          _this.checkAllAndroid = _this.checkedAndroid.length === _this.packageListAndroid.length;
          _this.checkAllHm = _this.checkedHm.length === _this.packageListHm.length;
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    summit() {
      let param = {};
      if(this.isDefaultPayee) {
        param['state'] = 1
      } else {
        param['state'] = 0
        let pnIdArr = [];
        if(this.checkedAndroid.length > 0) {
          for(let id of this.checkedAndroid) {
            pnIdArr.push(id);
          }
        }
        if(this.checkedHm.length > 0) {
          for(let id of this.checkedHm) {
            pnIdArr.push(id);
          }
        }
        param['packageNameIdArr'] = pnIdArr;
      }
      
      this.loading = true
      param['id'] = this.alipayForm.id
      postFormData(updatePayeeSetting, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getPackageChannelList();
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
  .showBox {
    height: 500px;
    width: 650px;
    margin-left: 8px;
    border: 1px solid #ededed;
    padding: 24px 0 24px 32px;
  }
</style>
